import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('mesInfoStore', Object.keys(getters)),
	...mapState('mesInfoStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('mesInfoStore', Object.keys(actions)),
	...mapMutations('mesInfoStore', Object.keys(mutations))
};
